import {
    AnimationBaseController,
    GameRandom,
} from "../../../../modules/@denishussar/html5-game-engine";
import { Inject } from "../../../../modules/@denishussar/html5-game-engine";
import { IAnimationControllerConfiguration } from "../../../../modules/@denishussar/html5-game-engine";
import { GameModel } from "../../../Models/GameModel";
import { AnimationContents } from "../../AnimationContents";
import { GameLogic } from "../../../Logic/GameLogic";
import { AbstractBgTileModel } from "../../../Models/BgContainerModels/TileModels/AbstractBgTileModel";

export interface IBgSimpleTileControllerOptions {
    libraryName: string
}

export class BgSimpleTileController extends AnimationBaseController {
    $model: AbstractBgTileModel;

    public constructor(@Inject private _options: IBgSimpleTileControllerOptions,
        @Inject private _random: GameRandom,
        @Inject private _gameLogic: GameLogic) {
        super("BgSimpleTileController");
    }

    protected getConfiguration(): IAnimationControllerConfiguration {

        return <IAnimationControllerConfiguration>{
            animationContent: AnimationContents.MAIN_SCREEN_JSON,
            libraryName: this._options.libraryName,
            childControllers: {

            },
            modelWatch: {
                "pos.x": (x: number) => {
                    this.x = x;
                }
            }
        };
    }

    protected onInitialize(): void {
        const { x, y } = this.$model.pos;
        this.x = x;
        this.y = y;
    }

    protected onLandscape(): void {
    }

    protected onPortrait(): void {
    }

    protected onUpdate(frameRate: number): void {
    }
}

